import React from 'react'
import { connect } from 'react-redux'
import 'moment/locale/pt-br'
import '../../../css/components/react-datepicker.css';
import Autorizacao from '../../../security/Autorizacao';
import {
  getAdminEmpresa,
  getFinanceiroAgencia, getFinanceiroCaixa,
  getGestorEmpresa,
  getOperadorEmpresa,
  PERFIL_ADMIN,
} from '../../../security/securityContext';
import AcoesFechamentoCaixa from '../AcoesFechamentoCaixa';


export class FechamentoCaixaAgencia extends React.Component {
  exibirIcone () {
    if (this.props.fechamento.exibirConteudo) {
      return <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => this.props.alterarExibicaoDetalhamentoFechamentoCaixa(this.props.fechamento, this.props.empresaSelecionada.id)}>
        &#xE5C7;</i>
    }
    return <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => this.props.alterarExibicaoDetalhamentoFechamentoCaixa(this.props.fechamento, this.props.empresaSelecionada.id)}>&#xE5C5;</i>
  }

  render () {
    return (
      <div>
        <div className="resumo" style={{ backgroundColor: this.props.isFechamentoDia ? '#fff3cd' : '' }}>
          <div className="row">
            <div className="col-lg-2 col-xl-2">
              <span className="titulo-mobile">Data:&nbsp;</span>
              {this.props.fechamento.dataFechamento}
            </div>
            <div className="col-lg-3 col-xl-3">
              <span className="titulo-mobile">Agente:&nbsp;</span>
              {this.props.fechamento.nomeAgencia}
            </div>
            <div className="col-lg-2 col-xl-2">
              <span className="titulo-mobile">Quantidade de vendas:&nbsp;</span>{this.props.fechamento.quantidadeVendas}
            </div>
            <div className="col-lg-2 col-xl-2">
              <span className="titulo-mobile">Valor total de vendas R$:&nbsp;</span>
              R$: {this.props.fechamento.totais.totalVendas}
            </div>
            <div className="col-lg-2 col-xl-2">
              <span className="titulo-mobile">Situação:&nbsp;</span>
              {this.props.fechamento.descricaoSituacao}
            </div>
            <div className="col-lg-1 col-xl-1">
              <Autorizacao
                perfisPermitidos={[PERFIL_ADMIN,
                  getGestorEmpresa(this.props.empresaSelecionada.id),
                  getAdminEmpresa(this.props.empresaSelecionada.id),
                  getFinanceiroCaixa(this.props.empresaSelecionada.id),
                  getOperadorEmpresa(this.props.empresaSelecionada.id),
                  getFinanceiroAgencia(this.props.empresaSelecionada.id)
                ]}>
                <AcoesFechamentoCaixa seAgencia={true} item={this.props.fechamento} paginaDetalhamento='detalhe-fechamento-agencia'/>
              </Autorizacao>
            </div>
          </div>
            <div className='row m-2'>
                <div className="col">
                  <strong>Valor total de comissão R$:&nbsp; {this.props.fechamento.totais.totalComissao}</strong>
                </div>
                <div className="col">
                   <strong>Valor total de depósito R$:&nbsp; {this.props.fechamento.totais.totalDeposito}</strong>
                </div>
            </div>
          {this.props.isFechamentoDia ? <div className='row ml-1'>
            <strong style={{ color: '#a17a19' }}>Fechamento do Dia</strong>
          </div> : ''}
        </div>
      </div>
    )
  }
}

export const mapStateToProps = state => (
  {
    empresaSelecionada: state.empresaSelecionada
  });

export default connect(mapStateToProps, {})(FechamentoCaixaAgencia)
